import { RechargeType } from './recharge.type';



const INITIAL_STATE = {


    //recharge

    rechargeTxnHistory: [],
    rechargeSection: 'txnHistory',
    selectedOperator: '',
    selectedCircle: '',
    rechargeMobileNo: '',
    rechargeAmount: '',
    rechargeAmount1: '',
    dthCustomerId: '',
    rechargeType: '',

    //recharge Transfer

    browsePlans: '',


    transferTotalAmount1: '',
    surcharge1: '',
    orderId1: '',
    amount1: '',
    createOrderReq1: '',
    createOrderRes1: '',
    createOrderStatusResponse1: '',
    moneyTransferProgress1: '',


    formDate:'',
    toDate:''

};

const rechargeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {



        //recharge

        case RechargeType.setBrowsePlans:
            return {
                ...state,
                browsePlans: action.payload,
            };
        case RechargeType.setRechargeTxhHistory:
            return {
                ...state,
                rechargeTxnHistory: action.payload,
            };


        case RechargeType.setShowRecargeSection:
            return {
                ...state,
                rechargeSection: action.payload,
            };

        case RechargeType.setCurrentOpertaor:
            return {
                ...state,
                selectedOperator: action.payload,
            };
        case RechargeType.setCurrenntCircle:
            return {
                ...state,
                selectedCircle: action.payload,
            };

        case RechargeType.setRechrgeMobile:
            return {
                ...state,
                rechargeMobileNo: action.payload,
            };
        case RechargeType.selectedRechargableAmnt:
            return {
                ...state,
                rechargeAmount: action.payload,
            };
        case RechargeType.selectedRechargableAmnt1:
            return {
                ...state,
                rechargeAmount1: action.payload,
            };

        case RechargeType.setRechargeType:
            return {
                ...state,
                rechargeType: action.payload,
            };

        //dth customer id
        case RechargeType.setDTHCustomerId:
            return {
                ...state,
                dthCustomerId: action.payload,
            };



        //dth Transfer
        case RechargeType.setMoneyTransferTotalAmount1:
            return {
                ...state,
                transferTotalAmount1: action.payload,
            };

        case RechargeType.setMoneyTransferSurChargeAmount1:
            return {
                ...state,
                surcharge1: action.payload,
            };


        case RechargeType.setOrderId1:
            return {
                ...state,
                orderId1: action.payload,
            };

        case RechargeType.setAmount1:
            return {
                ...state,
                amount1: action.payload,
            };


        case RechargeType.setStatusEnqResponse1:
            return {
                ...state,
                createOrderStatusResponse1: action.payload,
            };

        case RechargeType.setCreteOrderReq1:
            return {
                ...state,
                createOrderReq1: action.payload,
            };

        case RechargeType.setCreateOrderRes1:
            return {
                ...state,
                createOrderRes1: action.payload,
            };

        case RechargeType.setMoneyTransferProgress1:
            return {
                ...state,
                moneyTransferProgress1: action.payload,
            };
        case RechargeType.setFilterEndDate:
            return {
                ...state,
                toDate: action.payload,
            };
        case RechargeType.setFilterStartDate:
            return {
                ...state,
                formDate: action.payload,
            };
        case RechargeType.RESET:
            return INITIAL_STATE;

        default:
            return state;
    }

};

export default rechargeReducer; 